<template>
  <card-seplag :titulo="'Capacitação'" cor="#00acc1">
    <div class="p-col-12 avisos">
      <b>Cursos de capacitação se referem a participação em Congresso, curso, estágio profissional, eventos artísticos, eventos científicos, eventos culturais, eventos educacionais, Fórum, Intercâmbio, Palestra, Seminário, Simpósio, Treinamento em serviço, Oficina/Workshop.</b>
    </div>
   
    <card-seplag :titulo="'Capacitações cadastradas'" class="ajusteSecao" cor="#00acc1">
      <div class="p-col-12 ajusteSecao">
        <div v-if="capacitacoes && capacitacoes.length > 0" class="p-col-12 ajustePanel">
          <button v-for="(capacitacao, index) in capacitacoes" :key="capacitacao.idenCapacitacao" type="button"
            @click="funcaoAccord(index)" class="p-col-12 ajustePanel">
            <Panel :toggleable="true" :collapsed="controlePanel[index]" class="p-col-12 ajustePanel">
              <template slot="header">
                <span class="acordion">{{ colapseTeste }}</span>
                <span>
                  {{ index + 1 + " - " + capacitacao.descCurso }}
                  <span v-if="capacitacao.statCapacitacao == 'REJEITADO'"
                    class="statusVinculoIrregular alinhamentoNome">Rejeitado</span>
                  <span v-if="capacitacao.statCapacitacao == 'PENDENTE'"
                    class="statusVinculoPendente alinhamentoNome">Pendente</span>
                  <span v-if="capacitacao.statCapacitacao == 'PENDENTE_VALIDACAO'"
                    class="statusVinculoPendente alinhamentoNome">AGUARDANDO VALIDAÇÃO</span>
                  <span v-if="capacitacao.statCapacitacao == 'CONCLUIDO'"
                    class="statusVinculoConcluido alinhamentoNome">Concluído</span>
                  <span v-if="capacitacao.statCapacitacao == 'VALIDADO'"
                    class="statusVinculoConcluido alinhamentoNome">Validado</span>
                </span>
                <span class="acordion">{{ isCollapsed }}</span>
              </template>
              <div class="p-grid p-fluid">
                <div class="p-col-12 ajusteContent" v-if="capacitacao.codgModalidadeEnsinoSeap">
                  <label><strong>Modalidade: </strong>{{
                    verifcarModalidade(capacitacao.codgModalidadeEnsinoSeap)
                  }}</label>
                </div>
                <div class="p-col-12 ajusteContent" v-if="capacitacao.formacaoContinuada">
                  <label><strong>Eventos: </strong>{{
                    capacitacao.formacaoContinuada.nomeFormacaoContinuada
                  }}</label>
                </div>
                <div class="p-col-12 ajusteContent" v-if="capacitacao.descInstituicao">
                  <label><strong>Instituição: </strong>{{ capacitacao.descInstituicao }}</label>
                </div>
                <div class="p-col-12 ajusteContent" v-if="capacitacao.qtdeCargaHoraria">
                  <label><strong>Carga horária: </strong>{{ capacitacao.qtdeCargaHoraria }}</label>
                </div>
                <div class="p-col-12 p-md-12 ajusteContent" v-if="capacitacao.dataAnoConclusao">
                  <label><strong>Data da conclusão: </strong>{{ capacitacao.dataAnoConclusao }}</label>
                </div>
              </div>
            </Panel>
          </button>
        </div>

        <span v-else><i>Nenhum registro encontrado</i></span>
      </div>
    </card-seplag>

    <div class="p-col-12">
      <div class="p-grid">
        <div class="p-col-12 p-md-2 p-md-offset-3">
          <Button label="Voltar" @click="prevPage()" icon="pi pi-angle-left" />
        </div>
        <div class="p-col-12 p-md-2">
          <Button label="Próximo" @click="nextPage()" icon="pi pi-angle-right" iconPos="right" />
        </div>
      </div>
    </div>

  </card-seplag>
</template>
<script>
import CardSeplag from "@/template/CardSeplag.vue";
import { baseApiUrl } from "@/config/global";

const getDadosCapacitacao = () => {
  return {
    descCurso: null,
    areaFormacao: null,
    areaConhecimento: null,
    formacaoContinuada: null,
    qtdeCargaHoraria: null,
    dataAnoConclusao: "",
    descInstituicao: null,
    codgModalidadeEnsinoSeap: null,
  };
};

export default {
  name: "capacitacao",
  components: { CardSeplag },
  data: function () {
    return {
      dadosCapacitacao: getDadosCapacitacao(),
      areasConhecimento: [],
      areaformacoes: [],
      formacaoContinuada: [],
      capacitacoes: [],
      flagEdicao: false,
      controleAccord: [],
      exibirDialogoDeletar: false,
      exibirNovaCapacitacao: false,
      camposPreenchidos: false,
      selectedModalidade: null,
      modalidades: [
        { name: "EaD", code: "EAD" },
        { name: "SemiPresencial", code: "SEMIPRESENCIAL" },
        { name: "Presencial", code: "PRESENCIAL" },
      ],
      cursos: [],
      resultadoBusca: null,
      teste: null,
      listaCursos: [],
      isCollapsed: false,
      controlePanel: [],
      colapseTeste: [],
    };
  },
  methods: {
    async carregarDados() {
      if (this.$store.getters.getDadosPessoa) {
        this.areasConhecimento = this.$store.getters.getAreasConhecimento;
        this.formacaoContinuada = this.$store.getters.getFormacaoContinuadas;
        // this.areaformacoes = this.$store.getters.getAreaFormacoes;
          this.$http.get(`${baseApiUrl}/formacaocontinuadas/ativos`).then(res =>{
           this.formacaoContinuada = res.data
          })
         this.$http
          .get(
            `${baseApiUrl}/capacitacoes/ciclopessoa/${this.$store.getters.getDadosPessoa.idenCicloPessoa}`
          )
          .then((res) => {
            this.capacitacoes = res.data;
            for (let i = 0; i < this.capacitacoes.length; i++) {
              this.controlePanel[i] = true;
              this.colapseTeste[i] = false;
            }
          });

        this.$http.get(`${baseApiUrl}/areaformacoes/ativos`).then((res) => {
          this.cursos = res.data;
          this.cursos.forEach((item) => {
            if (item) {
              this.listaCursos.push(
                this.especialCharMask(item.descAreaFormacao)
              );
            }
          });
          this.cursos = this.listaCursos;
        });
      } else {
        this.$router.push({ name: "recadastramento" });
      }
      
    },
    novaCapacitacao() {
      this.dadosCapacitacao = getDadosCapacitacao();
      this.camposPreenchidos = false;
      this.flagEdicao = false;
    },
    
    nextPage() {
      this.$router.push({ name: "RECADVIEW_EXPERIENCIA_PROFISSIONAL_VIEW" });
    },
    prevPage() {
      this.$router.push({ name: "RECADVIEW_FORMACAO_ACADEMICA_VIEW" });
    },

    verifcarModalidade(codigoModalidade) {
      let codigoModalidadeAux = this.modalidades.find(
        (item) => item.code == codigoModalidade
      );
      return codigoModalidadeAux.name;
    }, //codigoModalidade.find()

    especialCharMask(str) {
      str = str.replace(/[àáâãäå]/g, "a");
      str = str.replace(/[ÀÁÂÃÄÅ]/g, "A");

      str = str.replace(/[éèêë]/g, "e");
      str = str.replace(/[ÉÈÊË]/g, "E");

      str = str.replace(/[íìîï]/g, "i");
      str = str.replace(/[ÍÌÎÏ]/g, "I");

      str = str.replace(/[óòõôö]/g, "o");
      str = str.replace(/[ÓÒÕÔÖ]/g, "O");

      str = str.replace(/[úùûü]/g, "u");
      str = str.replace(/[ÚÙÛÜ]/g, "U");

      str = str.replace(/[ç]/g, "c");
      str = str.replace(/[Ç]/g, "C");

      str = str.replace(/[!@#$%¬&*=+/?|°ºª§´^~¨()_"]/g, "");

      return str;
    },

    converteMaiuscula(atributo) {
      if (atributo == "dadosCapacitacao.descCurso") {
        this.dadosCapacitacao.descCurso = this.especialCharMask(
          this.dadosCapacitacao.descCurso.toUpperCase()
        );
      } else if (atributo == "dadosCapacitacao.descInstituicao") {
        this.dadosCapacitacao.descInstituicao = this.especialCharMask(
          this.dadosCapacitacao.descInstituicao.toUpperCase()
        );
      }
    },

    funcaoAccord(index) {
      this.controlePanel[index] = this.isCollapsed;
      this.isCollapsed = !this.isCollapsed;
      this.controlePanel[index] = this.colapseTeste[index];
      this.colapseTeste[index] = !this.colapseTeste[index];
    },

  },
  mounted() {
    this.carregarDados();
  },

};


</script>
<style>
.docConcluido {
  color: #43a047;
  margin-top: 2px;
  margin-left: 15px;
}

.docPendente {
  color: #f2bf27;
  margin-top: 2px;
  margin-left: 15px;
}

.statusVinculoPendente {
  color: #f2bf27;
  margin-right: 3px;
}

.statusVinculoIrregular {
  color: #f27777;
  margin-right: 3px;
}

.statusVinculoConcluido {
  color: #43a047;
  margin-right: 3px;
}

.divcontainerButton {
  margin-top: 1rem;
  width: 100%;
}

.divButton {
  width: 10% !important;
}

.pendenteEdicao {
  color: orange;
}

.ajusteSecao {
  margin-top: 20px;
}

.ajustaBotao {
  /* justify-items: ; */
  justify-content: space-between;
  margin-top: 20px;
}

.ajustePanel {
  margin-top: -15px;
}

.ajusteContent {
  display: flex;
  align-items: flex-start;
  justify-content: flex-start !important;
  justify-items: flex-start;
  margin-right: 1500px;
}

.acordion {
  display: none;
}
</style>
